<ng-container *transloco="let t; read: 'objEditors.activity'">
  <span
    [class]="spanClass ?? 'activity'"
    *ngIf="active !== undefined"
    [class.active]="active"
    >({{ title ?? t(active ? 'enabled' : 'disabled') }})</span
  >
</ng-container>
